export const recaptcha_sitekey = '6LdRjU8UAAAAAOMOtoNvKZjK88vXmJ7FonxXu7RN';
